var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeBusWaltti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6005 24H2.40034C1.07444 24 0 22.9256 0 21.6005V2.40034C0 1.07444 1.07444 0 2.40034 0H21.6005C22.9264 0 24.0008 1.07444 24.0008 2.40034V21.6005C24 22.9256 22.9256 24 21.6005 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0749 2.40033H5.92591C5.25534 2.40033 4.71092 2.9439 4.71092 3.61532V18.1943C4.71092 18.8649 5.25449 19.4093 5.92591 19.4093H18.0749C18.7455 19.4093 19.2899 18.8657 19.2899 18.1943V3.61532C19.2891 2.9439 18.7455 2.40033 18.0749 2.40033ZM9.29993 3.48577H14.7001V4.40019H9.29993V3.48577ZM6.85556 17.2316C6.34163 17.2316 5.92591 16.8151 5.92591 16.302C5.92591 15.788 6.34248 15.3723 6.85556 15.3723C7.3695 15.3723 7.78522 15.7889 7.78522 16.302C7.78606 16.8151 7.3695 17.2316 6.85556 17.2316ZM17.1444 17.2316C16.6305 17.2316 16.2148 16.8151 16.2148 16.302C16.2148 15.788 16.6313 15.3723 17.1444 15.3723C17.6584 15.3723 18.0741 15.7889 18.0741 16.302C18.0749 16.8151 17.6584 17.2316 17.1444 17.2316ZM18.0749 12.3776C18.0749 12.5977 17.9276 12.7899 17.7151 12.8467C16.8684 13.0744 14.6222 13.6019 12 13.6019C9.37782 13.6019 7.13158 13.0744 6.2849 12.8467C6.07238 12.7899 5.92506 12.5977 5.92506 12.3776V5.79382C5.92506 5.52543 6.14266 5.30783 6.41106 5.30783H17.5881C17.8565 5.30783 18.0741 5.52543 18.0741 5.79382V12.3776H18.0749Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78606 19.3881H5.9259V21.6005H7.78606V19.3881Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0749 19.3881H16.2148V21.6005H18.0749V19.3881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeBusWaltti);
export default __webpack_public_path__ + "static/media/mode-bus-waltti.7b64c9b48fc0bf0fd8a37f9f3764c72d.svg";
export { ForwardRef as ReactComponent };